import React, { useState } from 'react';
import { DialogBox } from '../DialogBox';
import { useCookieConsent } from '#root/queries/local';

export const CookieConsent: React.FC = () => {
    const { data: hasAcceptedCookies, setCookieConsent } = useCookieConsent();
    const [showRequiredDialog, setShowRequiredDialog] = useState(false);
    const isOpen = !hasAcceptedCookies || showRequiredDialog;

    const handleAccept = () => {
        setCookieConsent(true);
        setShowRequiredDialog(false);
    };

    const handleDecline = () => {
        setCookieConsent(false);
        setShowRequiredDialog(true);
    };

    if (showRequiredDialog) {
        return (
            <DialogBox
                open={isOpen}
                onOpenChange={() => {}}
                hideCloseButton={true}
                title="Cookies Required"
                primaryButtonText="Re-Open Cookies Consent"
                primaryButtonAppearance="primary"
                onPrimaryButtonClick={() => {
                    setShowRequiredDialog(false);
                    setCookieConsent(undefined); // Reset consent to show initial dialog
                }}
                showSecondaryButton={false}
            >
                To use this website, cookies must be enabled. Our site relies on essential
                cookies to support secure login and core functionality.
                <br /><br />
                Please enable cookies in your browser settings or return to the cookie
                preferences and allow at least essential cookies to continue.
            </DialogBox>
        );
    }

    return (
        <DialogBox
            open={isOpen}
            onOpenChange={() => {}}
            hideCloseButton={true}
            title="Allow Cookies"
            primaryButtonText="Accept All"
            primaryButtonAppearance="primary"
            onPrimaryButtonClick={handleAccept}
            showSecondaryButton={true}
            secondaryButtonText="Decline"
            onSecondaryButtonClick={handleDecline}
        >
            We use cookies to improve your browsing experience, analyze site traffic, and
            personalize content. By clicking "Accept All," you consent to our use of cookies.
        </DialogBox>
    );
};
